<template>
  <multiselect
    :filterable="true"
    :options="options"
    v-model="selected"
    :custom-label="label"
    :placeholder="placeholder"/>
</template>
<script>
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
  },
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    draw: {
      type: Number,
    },
    placeholder: {
      type: String
    },
    value: {
      type: Object
    },
    operatingUnit: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      baseUrl: "/api/wms/v1/master/cost-center-v2",
      options: [],
      selected: (this.multiple) ? [] : null
    };
  },
  methods: {
    get() {
      this.$http
        .get(this.baseUrl, {
          params: {
            order: "name",
            sort: "asc",
          }
        })
        .then(resp => {
          if (resp.code == 200) {
            resp.data.records.map(function (x) {
              return (x.label = x.code + " - " + x.name);
            });

            this.options = resp.data.records;
            this.autoSelectCostCenter();
          } else {
            this.options = []
            console.log(resp.data);
          }
        });
    },
    label(option) {
      return option.label;
    },
    autoSelectCostCenter() {
      if (this.operatingUnit.cost_center_id !== 0) {
        const selectedCostCenter = this.options.find(option => option.id === this.operatingUnit.cost_center_id);
        if (selectedCostCenter) {
          this.selected = selectedCostCenter;
        }
      }
    }
  },
  watch: {
    selected(newVal) {
      this.$emit('selected', newVal);
    },
    operatingUnit: {
      handler(newVal) {
        this.get();
      },
      immediate: true
    }
  },
  mounted() {
    this.get();
  }
};
</script>
